// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "90f77cbd9a39bf95f294d5548691eaa9" + ".js";
};